import axios from "axios";
import route from "ziggy-js";
import { RouteName } from "../Constants/routes";

export const loadConversationList = async ({ page = 1, type = 0, excludeIds = [] }) => {
    try {
        const response = await axios.get(route(RouteName.LoadMessages, { page, type, exclude_ids: excludeIds }));

        const data = response.data?.data?.data;

        return {
            success: true,
            data,
            hasNext: page < response.data?.data?.last_page
        };
    } catch (e) {
        return {
            success: false,
        };
    }
};

export const getValidConversationsFromSids = async ({ conversationSids }) => {
    try {
        const response = await axios.post(route(RouteName.CheckValidConversationSids), {
            conversation_sids: conversationSids
        });

        return {
            success: true,
            conversation_sids: response.data?.data?.conversation_sids ?? [],
        };
    } catch {
        return {
            success: false,
        };
    }
};

export const getConversationFromSids = async ({ conversationSids }) => {
    try {
        const response = await axios.post(route(RouteName.MessageGetBySids), {
            sids: conversationSids,
        });

        return {
            success: true,
            conversations: response.data?.data ?? [],
        };
    } catch (e) {
        return {
            success: false,
        };
    }
};

export const findConversationFromSid = async ({ conversationSid }) => {
    try {
        const response = await axios.post(route(RouteName.MessageFindBySid), {
            sid: conversationSid,
        });

        return response.data?.data;
    } catch (e) {
        console.info("New Conversation fetch failed");
        console.error(e, conversationSid);

        return null;
    }
};

export const createConversationLogById = async ({ conversationId }) => {
    try {
        await axios.post(route(RouteName.MessageCreateFirstReplyLog, { conversation_id: conversationId }));

        return {
            success: true,
        };
    } catch (e) {
        console.info("ConversationFirstReplyLog was created failed");
        console.error(e, conversationId);
        return {
            success: false,
        };
    }
};
